<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Consulta de CIE10</h3>
      </div>
      <div class="layout__controls">
        <form class="form-inline" method="POST" :action="action" enctype="multipart/form-data">
          <input type="hidden" name="_token" :value="token" />
          <div class="form-field">
            <label for="archivo">
              <strong>Importación CIE10</strong>
            </label>
            <input type="file" name="archivo" id="archivo" />
          </div>
          <div class="form-field">
            <button type="submit" class="btn-success">
              <i class="fa fa-upload"></i>
              <span>Subir</span>
            </button>
          </div>
        </form>
      </div>
    </div>
    <div class="card">
      <div class="card__content">
        <k-table
          ref="cie10"
          :path="path"
          :createButton="permiteCrear"
          :editButton="permiteEditar"
          :deleteButton="permiteEliminar"
          @editar="editar"
          @crear="crear"
          @eliminar="eliminar"
          exportable
          :columns="[
            {
              display: 'Cie10 Principal',
              value: 'padre.nombre'
            },
            {
              display: 'Código',
              value: 'codigo'
            },
            {
              display: 'Descripción',
              value: 'descripcion'
            },
            {
              display: 'Creación',
              value: 'created_at'
            },
            {
              display: 'Modificación',
              value: 'updated_at'
            }
          ]"
        ></k-table>
      </div>
    </div>
    <modal name="cie10" scrollable width="70%" height="auto">
      <k-cie10 v-model="selectedCie10" @saved="saved" @cancelar="cancelar"></k-cie10>
    </modal>
  </div>
</template>

<script>
export default {
  props: {
    action: {
      type: String,
      required: false,
      default: url + "/cie10/importar"
    },
    token: {
      type: String,
      required: true
    },
    permiteCrear: {
      type: Boolean,
      required: false,
      default: true
    },
    permiteEditar: {
      type: Boolean,
      required: false,
      default: true
    },
    permiteEliminar: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data: function() {
    return {
      selectedCie10: null,
      path: url + "/cie10",
      nuevoCie10: false,
      selectedIndex: -1
    };
  },
  methods: {
    crear: function() {
      this.nuevoCie10 = true;
      this.selectedCie10 = {
        codigo: "",
        descripcion: "",
        estado: "N",
        padre_id: ""
      };
      this.$modal.show("cie10");
    },
    editar: function(row) {
      this.nuevoCie10 = false;
      this.selectedCie10 = {
        id: row.id,
        codigo: row.codigo,
        descripcion: row.descripcion,
        estado: row.estado,
        padre_id: row.padre_id
      };
      this.selectedIndex = this.$refs.cie10.rows.indexOf(row);
      this.$modal.show("cie10");
    },
    eliminar: function(row) {
      let that = this;
      swal({
        title:
          "¿Está seguro de realizar la " +
          (row.estado === "A" ? "inactivación" : "activación") +
          " del cie10 seleccionado?",
        text: "Se requiere de confirmación del usuario",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí",
        cancelButtonText: "No"
      }).then(result => {
        if (result.value) {
          axios
            .post(url + "/cie10/" + row.id, {
              _method: "DELETE"
            })
            .then(function() {
              swal(
                "Se ha cambiado el estado del registro seleccionado.",
                "Realizado",
                "success"
              );
              that.$refs.cie10.loadRows();
            })
            .catch(function() {
              swal("Hubo un error, intente nuevamente.", "Error", "error");
            });
        }
      });
    },
    saved: function(row) {
      if (this.nuevoCie10) {
        this.$refs.cie10.rows.unshift(row);
        this.nuevoCie10 = false;
      } else this.$refs.cie10.rows.splice(this.selectedIndex, 1, row);
      this.$modal.hide("cie10");
    },
    cancelar: function() {
      this.nuevoCie10 = false;
      this.selectedIndex = -1;
      this.$modal.hide("cie10");
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/cie10/ConsultaCie10.vue